import { render } from "./OtorgarSolicitud.vue?vue&type=template&id=2150aee0"
import script from "./OtorgarSolicitud.vue?vue&type=script&lang=js"
export * from "./OtorgarSolicitud.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__